"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var useConfig_1 = __importDefault(require("./../../_util/useConfig"));
var List_1 = __importDefault(require("./List"));
function CircularLogo(props) {
    var data = props.data;
    var classPrefix = (0, useConfig_1.default)().classPrefix;
    var dataLength = (data === null || data === void 0 ? void 0 : data.length) || 0;
    var dataRangeFourAndEightLength = dataLength > 4 && dataLength < 8;
    /**
     * col占比
     * @param val
     * @param status
     */
    var returnCol = function (val, status) {
        var _a;
        if (dataRangeFourAndEightLength || !dataLength)
            return;
        var result = dataLength % val === 0;
        if (status) {
            result = dataLength % val !== 0;
        }
        return _a = {},
            _a["col-".concat(val)] = result,
            _a;
    };
    return (react_1.default.createElement("div", { className: "".concat(classPrefix, "__circular-logo") },
        react_1.default.createElement("div", { className: (0, classnames_1.default)("".concat(classPrefix, "__container"), __assign(__assign(__assign(__assign({ 'range-4': dataRangeFourAndEightLength }, returnCol(2, true)), returnCol(8)), returnCol(10)), returnCol(12))) }, data === null || data === void 0 ? void 0 : data.map(function (item, index) {
            return react_1.default.createElement(List_1.default, __assign({}, item, { key: index }));
        }))));
}
exports.default = CircularLogo;
//# sourceMappingURL=CircularLogo.js.map